export const classes = (...classes: Array<string | boolean | undefined>) => {
  return classes.filter(Boolean).join(' ');
}

export const formatAmount = (amount: string | number, symbol?: string) => {
  if (isNaN(+amount)) amount = 0;
  const formatted = Intl.NumberFormat('es-VE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(+amount);
  return !!symbol ? `${symbol || ''} ${formatted}` : formatted;
}

export const convertFrom24HourFormat = (time: string) => {
  const [hour, minute] = time.split(':').map(Number);
  let formattedHour = hour;
  let formattedIsAM = true;

  if (hour >= 12) {
    formattedIsAM = false;
    if (hour > 12) formattedHour -= 12; // Convertir PM
  } else if (hour === 0) {
    formattedHour = 12; // Convertir 00 a 12
  }

  return { formattedHour, minute, formattedIsAM };
};

export const truncateText = (text: string, maxLength: number = 10) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};